<template>
  <section>
    <!-- SB-01 -->
    <banner-full-width headerText="What's next"></banner-full-width>
    <div
      id="sb-52"
      v-if="$store.state.currentLocation >= 52"
    >
      <content-block>
        <!-- 5-01-00 -->
        <!-- <banner-full-width headerText=""></banner-full-width> -->
        <!-- <h1 class="animated infinite bounce delay-2s">Example</h1> -->
        <h2 class="content-block__header content-block__header--red">Rowing safety fundamentals </h2>
        <p>Here’s a quick recap of what you need to know and do to stay safe on the water.</p>
        <div class="accordion-group">
          <accordion
            header-text="Risk assessment"
            class="accordion--red "
          >
            <p>
              No matter how well prepared you are, if you see something in the water that you believe is unsafe, tell somebody.
            </p>
            <ul>
              <li>To assess your risk:
                <ul>
                  <li>Identify risks involved with your planned row. </li>
                  <li>Analyze those risks. </li>
                  <li>Plan for each risk. </li>
                </ul>
              </li>
            </ul>
          </accordion>
          <accordion
            header-text="Boating safety"
            class="accordion--red"
          >
            <p>All rowers and coaches are responsible for knowing and adhering to the Transport Canada regulations that affect boating. In addition:</p>
            <ul>
              <li>All operators must take whatever action is required to avoid accidents and collisions. </li>
              <li>The person steering the vessel is the responsible person in charge. Before starting your row, always establish who is in charge. </li>
              <li>Rowing in the dark, rowing before sunrise and rowing after sunset pose far greater risks and are not recommended by RCA.</li>
            </ul>
          </accordion>
          <accordion
            header-text="Environment and weather"
            class="accordion--red"
          >
            <ul>
              <li>If strong winds, whitecaps, thunder, lightning or fog are present before you go rowing, do not go on the water. </li>
              <li>If extreme weather conditions arise once you are on the water, return to the boathouse or get to the nearest safe haven.</li>
            </ul>
          </accordion>
          <accordion
            header-text="Athlete emergency response"
            class="accordion--red"
          >
            <ul>
              <li>Learn how to help yourself and others in case of an individual or crew emergency on the water.</li>
              <li>Remember, you are also responsible for the safety of those who may have to rescue you.</li>
              <li>Dress appropriately for the weather you’ll be rowing in, to guard against hypothermia or hyperthermia.</li>
              <li>Learn to recognize the signs and symptoms of concussion. If you suspect one, stop physical activity and seek medical attention immediately.</li>
            </ul>
          </accordion>
          <accordion
            header-text="Individual safety"
            class="accordion--red"
          >
            <p>Before you go on the water, consider your:</p>
            <ul>
              <li>Swimming ability</li>
              <li>PFD comfort level</li>
              <li>Knowledge of traffic on the waterway</li>
              <li>Planned row or workout</li>
            </ul>
          </accordion>
          <accordion
            header-text="Equipment"
            class="accordion--red"
          >
            <p>Before you take your shell to the water, check that all its components are fit for use; adjust any parts necessary. If any part is unsafe to use, do not go on the water.</p>
            <p>Check:</p>
            <ul>
              <li>Rowing shell parts</li>
              <li>Safety equipment in the shell</li>
              <li>Foot stretchers</li>
              <li>Seat</li>
              <li>Fin and bow ball</li>
              <li>Oars </li>
            </ul>
          </accordion>
        </div>
        <button-sequenced
          class="btn-nav--red"
          :loc="53"
          link="sb-53"
        >
          I will
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-53 -->
    <div
      id="sb-53"
      class="bg-img bg-img--04"
      v-if="$store.state.currentLocation >= 53"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Thank you </h2>
        <p>We appreciate your time and interest in rowing safety. </p>
        <p>Increasing your situational awareness on the water helps you and those around you to enjoy our sport safely and responsibly. </p>
        <button-sequenced
          class="btn-nav--red"
          :loc="54"
          link="menu"
        >
          I’ll row safely
        </button-sequenced>
      </content-block>
    </div>

    <!-- <footer
      class="course-menu"
      id="menu"
      v-if="$store.state.currentLocation >= 54"
    >
      <h3>Course Menu</h3>
      <cac-menu :menuItems="$store.state.menuItems"></cac-menu>
    </footer> -->
  </section>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import CacHeader from '@/components/cac-components/CacHeader.vue';
import CacMenu from '@/components/cac-components/CacMenu.vue';
import BannerFullWidth from '@/components/BannerFullWidth.vue';
import ContentBlock from '@/components/ContentBlock.vue';
import ButtonSequenced from '@/components/ButtonSequenced.vue';
import AccordionIcon from '@/components/AccordionIcon.vue';
import Accordion from '@/components/Accordion.vue';

// Quiz stuff
import QuizRadio from '@/components/QuizRadio.vue';
import QuizCheckbox from '@/components/QuizCheckbox.vue';

export default {
  name: 'nccp',
  components: {
    CacHeader,
    CacMenu,
    BannerFullWidth,
    ContentBlock,
    ButtonSequenced,
    AccordionIcon,
    Accordion,
    QuizRadio
  },
  data() {
    return {
      showModal: false,
      // 3-01-03
      q01: [
        // Q1
        {
          id: 0,
          questionText: `
            <p>You’re scheduled to go out on the water with a group of beginner rowers. It’s pretty grey out, but the water is calm. The weather forecast says there’s a 20% chance of thunderstorms in about 2 hours. They’re calling for strong winds if the storm hits.</p>
            <p>Is it safe to take the group out?</p>
          `,
          questionArray: [
            'Yes. It’s safe as long as you’re back in an hour, before the storm arrives.',
            'Yes. It’s safe, since the chance of a storm is low.',
            'No. It’s too risky.',
          ],
          corrective: 'No. It’s too risky.',
          model: [],
          answer: '',
          answerText: `
            <p>Even though the storm isn’t scheduled to hit for 2 hours, weather can change quickly. A storm will create rough conditions that make it hard to get back to the dock, especially for beginner rowers.</p>
          `,
        },
      ],
    };
  },
  methods: {
    tabContent(index) {
      this.tabIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
/*------------------------------------*\
    #PRIMARY COLOURS
  \*------------------------------------*/

/*------------------------------------*\
    #Mixins
  \*------------------------------------*/

/*------------------------------------
    #MEDIA SCREENS < 768px (#MOBILE FIRST)
  \*------------------------------------*/
.banner {
  // background-image: url('../assets/img/_chapter-headers/mbl/01-welcome-mbl.png');
  background-image: url("../assets/img/_chapter-headers/mbl/8-whats-next-mbl.jpg");
  color: #000;
  background-position: center;
  padding: 60% 10%;
  &__header {
    color: #000;
  }
}

/*------------------------------------*\
    #MEDIA SCREENS > 576px (TABLETS)
  \*------------------------------------*/
@media (min-width: 576px) {
  .banner {
    background-image: url("../assets/img/_chapter-headers/dsk/8-whats-next-dsk.jpg");
    // background-image: url('../assets/img/_chapter-headers/dsk/01-welcome-dsk.png');
    color: #000;
    padding: 10% 10% 14%;
    background-position: center;
    &__header {
      color: #000;
    }
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
  // .banner {
  //   background-image: url('../assets/img/_bg/1-01-01-bg-dsk.png');
  //   color: #fff;
  //   padding: 10% 10%;
  //   background-position: center;
  //   &__header {
  //       color: #fff;
  //   }
  // }
}

/*------------------------------------*\
    #MEDIA SCREENS > 992px
    (LAPTOP, TABLET)
  \*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1200px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1320px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1600px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
